const isDevServer = (process.env.WEBPACK_SERVE ?? false);
const deployEnv = (process.env.DEPLOY_MODE ?? "local");
const toCdnOrigin = (
  prodCdnOrigin: string,
  devCdnOrigin: string,
  localOrigin: string
) => {
  //process.env.* 의 변수 구조는 webpack에 의해서 변화되는것이니 크게 건들면 안됨.
  if (isDevServer) {
    return localOrigin;
  }
  switch (deployEnv) {
    case "prod":
      return prodCdnOrigin;
    case "dev":
      return devCdnOrigin;
    default:
      return localOrigin;
  }
};

export const NOTIFICATION_CDN_ORIGIN = toCdnOrigin(
  "https://notification.talktomeinkorean.com",
  "https://notification.talktomeinkorean.kr",
  "http://127.0.0.1:3001"
);
export const ROADMAP_CDN_ORIGIN = toCdnOrigin(
  "https://roadmap.talktomeinkorean.com",
  "https://roadmap.talktomeinkorean.kr",
  "http://127.0.0.1:3002"
);

export const LANDING_CDN_ORIGIN = toCdnOrigin(
  "https://landing-app.talktomeinkorean.com",
  "https://landing-app.talktomeinkorean.kr",
  "http://127.0.0.1:3003"
);

export const CURATION_CDN_ORIGIN = toCdnOrigin(
  "https://curation-app.talktomeinkorean.com",
  "https://curation-app.talktomeinkorean.kr",
  "http://127.0.0.1:3004"
);

export const AUDIO_CDN_ORIGIN = toCdnOrigin(
  "https://audio.talktomeinkorean.com",
  "https://audio.talktomeinkorean.kr",
  "http://127.0.0.1:3005"
);

export const PRICING_CDN_ORIGIN = toCdnOrigin(
  "https://pricing-app.talktomeinkorean.com",
  "https://pricing-app.talktomeinkorean.kr",
  "http://127.0.0.1:3006"
);


export const AUTH_CDN_ORIGIN = toCdnOrigin(
  "https://auth-app.talktomeinkorean.com",
  "https://auth-app.talktomeinkorean.kr",
  "http://127.0.0.1:3007"
);


